import { useIntl } from 'react-intl';
import defaultAvatar from './defaultAvatar.svg';
import { CSSProperties } from 'react';
export interface AgAvatarProps {
  alt?: string;
  src: string | undefined;
  style?: CSSProperties;
}

const AgAvatar = (
  {
    alt,
    src,
    style
  }: AgAvatarProps
) => {
  const messages = useIntl().formatMessage;
  const avatarSrc = src || defaultAvatar;
  const avatarAlt = alt || messages({ id: 'AVATAR_ALT' });

  return (
    <img src={avatarSrc} alt={avatarAlt} style={{ width: '56px', height: '56px', borderRadius: '8px', ...style }} />
  );
};

export default AgAvatar;